// Jobber API Configuration
export const JOBBER_CONFIG = {
  // Your OAuth credentials
  clientId: '5a77418c-e294-4c43-a91f-b6167ef7cf5f',
  clientSecret: 'e24cb8a984726c4d3bd3987fd28e5833cb2aa2106a35a0fbfe757da07fd2e465',
  
  // OAuth URLs
  authUrl: 'https://api.getjobber.com/api/oauth/authorize',
  tokenUrl: 'https://api.getjobber.com/api/oauth/token',
  
  // GraphQL endpoint
  graphqlUrl: 'https://api.getjobber.com/api/graphql',
  
  // Scopes needed for quotes and customers
  scopes: [
    'read:customers',
    'write:customers', 
    'read:quotes',
    'write:quotes',
    'read:jobs',
    'write:jobs'
  ].join(' ')
};

// Get redirect URI based on environment
// Jobber automatically supports 127.0.0.1 for localhost development
export const getRedirectUri = () => {
  // Check if running on localhost (development)
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
  
  if (isLocalhost) {
    // Use window.location.origin to auto-detect port (e.g., http://127.0.0.1:3000)
    return typeof window !== 'undefined' ? window.location.origin : 'http://127.0.0.1:3000';
  }
  
  // Production: use squeekit.com
  return 'https://squeekit.com';
};

// Generate OAuth authorization URL. Pass userId to encode in state so callback can store tokens in Firestore.
export const getJobberAuthUrl = (userId) => {
  const random = generateRandomState();
  const state = userId ? `${userId}|${random}` : random;
  const redirectUri = getRedirectUri();
  const params = new URLSearchParams({
    client_id: JOBBER_CONFIG.clientId,
    redirect_uri: redirectUri,
    response_type: 'code',
    scope: JOBBER_CONFIG.scopes,
    state: state
  });

  const authUrl = `${JOBBER_CONFIG.authUrl}?${params.toString()}`;
  console.log('Jobber OAuth URL Components:', {
    baseUrl: JOBBER_CONFIG.authUrl,
    clientId: JOBBER_CONFIG.clientId,
    redirectUri: redirectUri,
    scopes: JOBBER_CONFIG.scopes,
    state: state,
    fullUrl: authUrl
  });

  return authUrl;
};

/** Parse state from OAuth callback; returns { userId, state } if state contained userId. */
export const parseJobberState = (stateParam) => {
  if (!stateParam || typeof stateParam !== 'string') return { userId: null, state: stateParam };
  const idx = stateParam.indexOf('|');
  if (idx === -1) return { userId: null, state: stateParam };
  return { userId: stateParam.slice(0, idx), state: stateParam };
};

// Generate random state for OAuth security
const generateRandomState = () => {
  return Math.random().toString(36).substring(2, 15) +
         Math.random().toString(36).substring(2, 15);
};

// Exchange authorization code for access token
export const exchangeCodeForToken = async (code) => {
  try {
    const redirectUri = getRedirectUri();
    console.log('🔄 Exchanging authorization code for token...');
    console.log('📝 Code:', code);
    console.log('🔗 Token URL:', JOBBER_CONFIG.tokenUrl);
    console.log('🔗 Redirect URI:', redirectUri);
    
    const response = await fetch(JOBBER_CONFIG.tokenUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams({
        grant_type: 'authorization_code',
        client_id: JOBBER_CONFIG.clientId,
        client_secret: JOBBER_CONFIG.clientSecret,
        redirect_uri: redirectUri,
        code: code
      })
    });

    console.log('📡 Token exchange response status:', response.status);
    console.log('📡 Token exchange response headers:', response.headers);

    if (!response.ok) {
      const errorText = await response.text();
      console.error('❌ Token exchange failed:', errorText);
      throw new Error(`Token exchange failed: ${response.statusText} - ${errorText}`);
    }

    const tokenData = await response.json();
    console.log('✅ Token exchange successful:', tokenData);
    return tokenData;
  } catch (error) {
    console.error('❌ Error exchanging code for token:', error);
    throw error;
  }
};

// Refresh access token
export const refreshAccessToken = async (refreshToken) => {
  try {
    const response = await fetch(JOBBER_CONFIG.tokenUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams({
        grant_type: 'refresh_token',
        client_id: JOBBER_CONFIG.clientId,
        client_secret: JOBBER_CONFIG.clientSecret,
        refresh_token: refreshToken
      })
    });

    if (!response.ok) {
      throw new Error(`Token refresh failed: ${response.statusText}`);
    }

    const tokenData = await response.json();
    return tokenData;
  } catch (error) {
    console.error('Error refreshing token:', error);
    throw error;
  }
};
